import { Buffer as a } from "buffer";
const c = [
  "partoo-business-photos-test",
  "partoo-media",
  "partoo-image-download",
  "partoo-image-resized"
], i = /\.s3\.amazonaws\.com/i, p = "https://image-resize.partoo.co", m = (t) => {
  try {
    const e = new URL(t), s = e.host?.replace(i, "") ?? "";
    let o = e.pathname?.replace(/^\//, "") ?? "";
    o = decodeURIComponent(o), o = o.replaceAll("+", " ");
    const r = [".png", ".jpeg", ".jpg"];
    return !s || !c.includes(s) || !r.some((n) => o.toLowerCase().endsWith(n)) ? null : { bucket: s, key: o };
  } catch (e) {
    return console.warn("Error parsing URL:", t, `
`, e), null;
  }
}, d = (t, e) => {
  const s = m(e);
  if (!s) return e;
  const o = JSON.stringify({ ...s, ...t }), r = a.from(o).toString("base64");
  return `${p}/${r}`;
}, u = ({
  url: t,
  urlMapping: e,
  width: s = 1920,
  height: o = 1080,
  fit: r = "inside"
}) => {
  const n = e?.[t] ? e[t] : t;
  return d({
    edits: {
      resize: {
        width: s,
        height: o,
        fit: r
      }
    }
  }, n);
};
export {
  u as resizeImage
};
